// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ce352978","455":"36ca223a","977":"04021fde"}[chunkId] + ".chunk.js";
};